var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoundedDarkAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1115 -803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,19.5a.464.464,0,0,1-.5-.417V-.083A.464.464,0,0,1,0-.5a.464.464,0,0,1,.5.417V19.083A.464.464,0,0,1,0,19.5Z",
    transform: "translate(1135 813.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5,20a.464.464,0,0,1-.5-.417V.417A.464.464,0,0,1,.5,0,.464.464,0,0,1,1,.417V19.583A.464.464,0,0,1,.5,20Z",
    transform: "translate(1145 822.5) rotate(90)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundedDarkAdd);
export default __webpack_public_path__ + "static/media/icon_rounded_dark_add.5699b602d319e719a152356f32f041b8.svg";
export { ForwardRef as ReactComponent };